import React, { useState } from 'react';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import KlarityHeader from 'components/KlarityHeader';
import { Button } from 'antd';
import { PATH } from 'constants/path';
import { getUrlParam } from 'utils/common';
import { openVideoVisitUnSubmittedDrawer } from 'utils/globalLayerControl';
import useTreatmentAppointmentDetail from 'hooks/treatment/useTreatmentAppointmentDetail';
import useLoadBasicData from 'hooks/useLoadBasicData';

export default function MeetingEndPage() {
    const navigate = useNavigate();
    const [hasTreatmentPlan, setHasTreatmentPlan] = useState(false);
    const [appointmentId, setAppointmentId] = useState<number | undefined>();
    const [treatmentDetail, loadingTreatmentDetail, fetchTreatmentDetail] =
        useTreatmentAppointmentDetail(appointmentId);
    // 本页是布局外的独立路由，ProviderStore 等基础数据不会由 Layout 拉取，
    // 需自行加载（VideoVisitUnSubmittedDrawer 的签名弹窗等依赖 provider 信息）
    const [loadBasicData] = useLoadBasicData();

    React.useEffect(() => {
        loadBasicData();
    }, [loadBasicData]);

    React.useEffect(() => {
        const _hasTreatmentPlan = getUrlParam('hasTreatmentPlan') === 'true';
        setHasTreatmentPlan(_hasTreatmentPlan);
        const _appointmentId = getUrlParam('appointmentId');
        setAppointmentId(_appointmentId ? Number(_appointmentId) : undefined);
    }, []);

    const showVisitNotesBtn =
        !!appointmentId && !loadingTreatmentDetail && !!treatmentDetail && !treatmentDetail.providerTreatmentSubmitted;
    const hasDraft = hasTreatmentPlan || !!treatmentDetail?.treatmentPlan;

    return (
        <div className={s.wrap}>
            <KlarityHeader />
            <div className={s.content}>
                <div className={s.modal}>
                    <div className={s.icon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M28.7287 6.81476C29.1036 7.18981 29.3143 7.69843 29.3143 8.22876C29.3143 8.75908 29.1036 9.2677 28.7287 9.64275L13.738 24.6334C13.5399 24.8316 13.3047 24.9888 13.0459 25.096C12.787 25.2032 12.5095 25.2584 12.2294 25.2584C11.9492 25.2584 11.6717 25.2032 11.4128 25.096C11.154 24.9888 10.9188 24.8316 10.7207 24.6334L3.27269 17.1868C3.08167 17.0023 2.9293 16.7816 2.82448 16.5376C2.71967 16.2936 2.66449 16.0311 2.66218 15.7656C2.65988 15.5 2.71048 15.2366 2.81104 14.9908C2.9116 14.7451 3.06011 14.5217 3.2479 14.334C3.43568 14.1462 3.65899 13.9977 3.90478 13.8971C4.15057 13.7965 4.41393 13.7459 4.67949 13.7483C4.94505 13.7506 5.20749 13.8057 5.45149 13.9106C5.6955 14.0154 5.91619 14.1677 6.10069 14.3588L12.2287 20.4868L25.8994 6.81476C26.0851 6.6289 26.3056 6.48147 26.5484 6.38088C26.7911 6.28029 27.0513 6.22852 27.314 6.22852C27.5768 6.22852 27.837 6.28029 28.0797 6.38088C28.3224 6.48147 28.543 6.6289 28.7287 6.81476Z"
                                fill="#0E62F4"
                            />
                        </svg>
                    </div>
                    <div className={s.title}>Thank you for completing this visit!</div>
                    <div>
                        <Button className={s.btn} type="primary" size="large" onClick={() => navigate(PATH.DASHBOARD)}>
                            Go to dashboard
                        </Button>
                    </div>
                    {showVisitNotesBtn && (
                        <div>
                            <Button
                                className={s.btn}
                                size="large"
                                onClick={() =>
                                    openVideoVisitUnSubmittedDrawer(appointmentId!, () => fetchTreatmentDetail(appointmentId!))
                                }
                            >
                                {hasDraft ? 'Continue editing visit notes' : 'Start visit notes'}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
